import angular from 'angular';
import simpleFilters from './filters.simple';

let filters = angular.module('shared.filters', [])
  .filter('capitalize', simpleFilters.capitalize)
  .filter('s4bCurrency', simpleFilters.s4bCurrency)
  .filter('fileSize', simpleFilters.fileSize)
  .filter('ngEnter', simpleFilters.ngEnter)
  .filter('b2bModalSelect', simpleFilters.b2bModalSelect)
  .filter('textFilterFilter', simpleFilters.textFilterFilter)
  .filter('joinBy',simpleFilters.joinBy);


export default filters;



/** WEBPACK FOOTER **
 ** ./www/components/shared/filters/filters.js
 **/